import colors from "../styles/colors/colors";

export const Min_Vh_100 = {
    minHeight: '100vh',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1000,
    background: colors.primary.main
}

export const LoginCircle1 = {
    width: '440px',
    height: '440px',
    borderRadius: '50%',
    position: 'absolute',
    bottom: '-180px',
    left: '-85px',
    backgroundColor: colors.white[1],
    border: `${colors.white[1]} solid 20px` 
}

export const LoginCircle2 = {
    width: '500px',
    height: '500px',
    borderRadius: '50%',
    position: 'absolute',
    bottom: '-215px',
    left: '-115px',
    backgroundColor: 'transparent',
    border: `#55C995 solid 8px` 
}
export const LoginCircle3 = {
    width: '600px',
    height: '600px',
    borderRadius: '50%',
    position: 'absolute',
    top: '-200px',
    right: '-200px',
    backgroundColor: 'transparent',
    border: `#fff solid 8px` 
}
export const LoginCircle4 = {
    width: '540px',
    height: '540px',
    borderRadius: '50%',
    position: 'absolute',
    top: '-175px',
    right: '-175px',
    backgroundColor: 'transparent',
    border: `#55C995 30px solid` 
}
export const LoginCircle5 = {
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    position: 'absolute',
    top: '100px',
    left: '150px',
    backgroundColor: '#55C995', 
}

